import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {
  ListItemButton,
  ListItemText,
  Box,
  Collapse,
  List,
  Divider,
} from '@mui/material';
import { ClassificationGroup, ClassificationItem } from '../categories.utility';
import { Classification } from '@/store/classificationsApi';

interface AccountExpandableListItemsProps {
  accountTypes: ClassificationGroup[];
  openCategories: Record<string, boolean>;
  selectedClassification: ClassificationItem | null;
  handleCategoryClick: (classificationName: Classification['Name']) => void;
  handleClassificationClick: (classification: ClassificationItem) => void;
}

const AccountExpandableListItems = ({
  accountTypes,
  openCategories,
  handleCategoryClick,
  selectedClassification,
  handleClassificationClick,
}: AccountExpandableListItemsProps) => {
  return accountTypes.map((accountType) => {
    const isOpen = openCategories[accountType.name] || false;

    return (
      <div key={accountType.name}>
        <ListItemButton
          onClick={() => handleCategoryClick(accountType.name)}
          sx={{
            background:
              'linear-gradient(90deg, rgba(214, 222, 226, 0.20) 0%, rgba(214, 222, 226, 0.50) 100%)',
          }}
        >
          <ListItemText
            primary={<Box sx={{ fontWeight: 'bold' }}>{accountType.name}</Box>}
          />
          {isOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse
          in={isOpen}
          timeout='auto'
          unmountOnExit
        >
          {accountType.items.map((item, itemIndex) => (
            <div key={`${accountType.name}-${itemIndex}`}>
              <List
                component='div'
                disablePadding
              >
                <ListItemButton
                  sx={{ pl: 6 }}
                  selected={
                    (selectedClassification?.uiKey &&
                      item.uiKey &&
                      selectedClassification.uiKey === item.uiKey) ||
                    (!selectedClassification?.uiKey &&
                      !item.uiKey &&
                      selectedClassification?.ClassificationId ===
                        item.ClassificationId)
                  }
                  onClick={() => handleClassificationClick(item)}
                >
                  <ListItemText primary={item.Name} />
                </ListItemButton>
                <Divider component='li' />
              </List>
            </div>
          ))}
        </Collapse>
      </div>
    );
  });
};

export default AccountExpandableListItems;
